import { Checkbox } from "@mantine/core";
import { useEffect, useState } from "react";
import { useTheme } from "src/hooks";
import { Flex } from "src/styled";

import { ICheckListItem } from "../CheckLists.types";

interface Props extends ICheckListItem {
  onChange: (checked: boolean, item: ICheckListItem) => void;
}

const ChecklistGroupItem = ({ onChange, ...props }: Props) => {
  const theme = useTheme();
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    onChange(checked, props);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
  }, [checked]);
  return (
    <Flex
      onClick={() => setChecked(!checked)}
      style={{
        cursor: "pointer",
        color: checked ? theme.colors!.main![8] : theme.colors!.main![5],
      }}
      align="center"
      mb={5}
      ml={5}
      gap={10}>
      {props.name}
      <Checkbox
        style={{ cursor: "pointer" }}
        checked={checked}
        onChange={event => setChecked(event.currentTarget.checked)}
      />
    </Flex>
  );
};
export default ChecklistGroupItem;
